import * as Actions from '../actions/loadSpinner.actions'

const initialState = {
  isLoading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.FULLSCREEN_LOADING_START: {
      return {
        ...initialState,
        isLoading: true,
      }
    }
    case Actions.FULLSCREEN_LOADING_END: {
      return {
        ...initialState,
        isLoading: false,
      }
    }
    default: {
      return state
    }
  }
}
